import { render, staticRenderFns } from "./ChampionshipCard.vue?vue&type=template&id=ad76c2ca&functional=true&"
import script from "./ChampionshipCard.vue?vue&type=script&lang=js&"
export * from "./ChampionshipCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ChampionshipCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports